import { Component, ViewEncapsulation, OnInit, ChangeDetectorRef } from '@angular/core';
import { VehicleService } from '../../../services/vehicle/vehicle.service';
import { ViewMasterService } from '../../../services/view-master/view-master.service';
import { VendorService } from '../../../services/vendor/vendor.service';
import { FuelService } from '../../../services/fuel/fuel.service';
import { TransmissionService } from '../../../services/transmission/transmission.service';
import { ClientService } from '../../../services/user/client.service';
import { UserService } from '../../../services/user/user.service';
import { ShipService } from '../../../services/ship/ship.service';
import { GeneralService } from '../../../services/general/general.service';
import { PaginatedResponse, PaginationInfo } from '../../../shared/models/api-response.interface';
import { InventoryCar } from '../../../shared/models/car.interface';
import { DestructorComponent } from '../../../components/destructor/destructor.component';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
declare var Swal: any;

export interface ColumnConfig {
  field: string;
  header: string;
  type: 'vehicle' | 'charge';
  minWidth?: string;
  format?: 'text' | 'price' | 'date' | 'mileage' | 'badge';
}

// Define filter interface
interface InventoryFilters {
  purchase_date_from?: string;
  purchase_date_to?: string;
  yard_in_date_from?: string;
  yard_in_date_to?: string;
  insp_date_from?: string;
  insp_date_to?: string;
  masho_date_from?: string;
  masho_date_to?: string;
  sold_date_from?: string;
  sold_date_to?: string;
  etd_from?: string;
  etd_to?: string;
  eta_from?: string;
  eta_to?: string;
  insp_status?: string;
  yard?: string;
  year_from?: string;
  year_to?: string;
  buyer_name?: any;
  buyer_name_id?: string;
  auction_name?: string;
  fuel_type?: string;
  transmission?: string;
  auction_date_from?: string;
  auction_date_to?: string;
  keyword_search?: string;
  sales_person?: any;
  sales_person_id?: string;
  stock_number?: string;
  source?: string[];
  ship_name?: any;
  ship_name_id?: string;
  shipping_company?: string;
}

@Component({
  selector: 'app-vh-inventory',
  templateUrl: './vh-inventory.component.html',
  styleUrls: ['./vh-inventory.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VhInventoryComponent extends DestructorComponent implements OnInit {

  // Data properties
  vehicles: InventoryCar[] = [];
  paginationInfo: PaginationInfo = {
    currentPage: 1,
    perPage: 20,
    total: 0,
    lastPage: 1,
    firstPage: 1
  };

  // View Master dropdown
  viewMasters: any[] = [];
  selectedViewMaster: string = '';
  selectedViewMasterData: any = null;

  // Column configuration - maps field names to their configurations
  allColumns: ColumnConfig[] = [
    // Vehicle Fields
    { field: 'Arrival port', header: 'Arrival Port', type: 'vehicle', minWidth: '120px' },
    { field: 'Auction date', header: 'Auction Date', type: 'vehicle', minWidth: '120px', format: 'date' },
    { field: 'Auction Name', header: 'Auction Name', type: 'vehicle', minWidth: '150px' },
    { field: 'Avg Ex Rate', header: 'Avg Ex Rate', type: 'vehicle', minWidth: '120px' },
    { field: 'Balance Amount', header: 'Balance Amount', type: 'vehicle', minWidth: '120px', format: 'price' },
    { field: 'Balance Finalized Date', header: 'Balance Finalized Date', type: 'vehicle', minWidth: '150px', format: 'date' },
    // { field: 'Book Req. Date', header: 'Book Req. Date', type: 'vehicle', minWidth: '120px', format: 'date' },
    { field: 'Book Req. Rate', header: 'Book Req. Rate', type: 'vehicle', minWidth: '120px' },
    { field: 'Booking Status', header: 'Booking Status', type: 'vehicle', minWidth: '120px', format: 'badge' },
    { field: 'Buyer Name', header: 'Buyer Name', type: 'vehicle', minWidth: '150px' },
    { field: 'Car Category', header: 'Car Category', type: 'vehicle', minWidth: '120px' },
    { field: 'CC', header: 'CC', type: 'vehicle', minWidth: '100px' },
    { field: 'Charges', header: 'Charges', type: 'vehicle', minWidth: '120px' },
    { field: 'Chassis Number', header: 'Chassis Number', type: 'vehicle', minWidth: '150px' },
    { field: 'Color', header: 'Color', type: 'vehicle', minWidth: '100px' },
    { field: 'Consignee Address1', header: 'Consignee Address', type: 'vehicle', minWidth: '180px' },
    { field: 'Consignee City', header: 'Consignee City', type: 'vehicle', minWidth: '120px' },
    { field: 'Consignee Country', header: 'Consignee Country', type: 'vehicle', minWidth: '120px' },
    { field: 'Consignee Email', header: 'Consignee Email', type: 'vehicle', minWidth: '180px' },
    { field: 'Consignee Name', header: 'Consignee Name', type: 'vehicle', minWidth: '150px' },
    { field: 'Consignee Tel1', header: 'Consignee Tel', type: 'vehicle', minWidth: '120px' },
    { field: 'Consignee Tel2', header: 'Consignee Tel 2', type: 'vehicle', minWidth: '120px' },
    { field: 'Container Number', header: 'Container Number', type: 'vehicle', minWidth: '150px' },
    { field: 'CTN Group No.', header: 'CTN Group No.', type: 'vehicle', minWidth: '120px' },
    { field: 'Currency', header: 'Currency', type: 'vehicle', minWidth: '100px' },
    { field: 'Departing Port', header: 'Departing Port', type: 'vehicle', minWidth: '120px' },
    { field: 'Doors', header: 'Doors', type: 'vehicle', minWidth: '100px' },
    { field: 'Drive', header: 'Drive', type: 'vehicle', minWidth: '100px' },
    { field: 'Engine Model', header: 'Engine Model', type: 'vehicle', minWidth: '120px' },
    { field: 'ETA', header: 'ETA', type: 'vehicle', minWidth: '120px', format: 'date' },
    { field: 'ETD', header: 'ETD', type: 'vehicle', minWidth: '120px', format: 'date' },
    { field: 'Ext. Grade', header: 'Est Grade', type: 'vehicle', minWidth: '120px' },
    { field: 'Freight Rate', header: 'Freight Rate', type: 'vehicle', minWidth: '120px', format: 'price' },
    { field: 'Freight Amount', header: 'Freight Amount', type: 'vehicle', minWidth: '120px', format: 'price' },
    { field: 'Fuel', header: 'Fuel', type: 'vehicle', minWidth: '100px' },
    { field: 'Height (cm)', header: 'Height (cm)', type: 'vehicle', minWidth: '120px' },
    { field: 'Insp. Date', header: 'Insp. Date', type: 'vehicle', minWidth: '120px', format: 'date' },
    { field: 'Insp. Status', header: 'Insp. Status', type: 'vehicle', minWidth: '120px' },
    { field: 'Inv. Amount', header: 'Inv Amount', type: 'vehicle', minWidth: '120px', format: 'price' },
    { field: 'Invoice Total', header: 'Inv Total', type: 'vehicle', minWidth: '120px', format: 'price' },
    { field: 'Length (cm)', header: 'Length (cm)', type: 'vehicle', minWidth: '120px' },
    { field: 'Load Capacity(kg)', header: 'Load Capacity (kg)', type: 'vehicle', minWidth: '150px' },
    { field: 'Lot Number', header: 'Lot Number', type: 'vehicle', minWidth: '120px' },
    { field: 'M3', header: 'M3', type: 'vehicle', minWidth: '100px' },
    { field: 'Make', header: 'Make', type: 'vehicle', minWidth: '120px' },
    { field: 'Maker Grade', header: 'Maker Grade', type: 'vehicle', minWidth: '120px' },
    { field: 'Masho Date', header: 'Masho Date', type: 'vehicle', minWidth: '120px', format: 'date' },
    { field: 'Master BOL No. (BL Number)', header: 'Master BOL No (BL Number)', type: 'vehicle', minWidth: '180px' },
    { field: 'Mfg Month', header: 'Mfg Month', type: 'vehicle', minWidth: '120px' },
    { field: 'Mfg Year', header: 'Mfg Year', type: 'vehicle', minWidth: '120px' },
    { field: 'Mileage (km)', header: 'Mileage (km)', type: 'vehicle', minWidth: '120px', format: 'mileage' },
    { field: 'Model', header: 'Model', type: 'vehicle', minWidth: '120px' },
    { field: 'Model Code', header: 'Model Code', type: 'vehicle', minWidth: '120px' },
    { field: 'Notify Party Address1', header: 'Notify Party Address 1', type: 'vehicle', minWidth: '180px' },
    { field: 'Notify Party City', header: 'Notify Party City', type: 'vehicle', minWidth: '120px' },
    { field: 'Notify Party Country', header: 'Notify Party Country', type: 'vehicle', minWidth: '120px' },
    { field: 'Notify Party Email', header: 'Notify Party Email', type: 'vehicle', minWidth: '180px' },
    { field: 'Notify Party Name', header: 'Notify Party Name', type: 'vehicle', minWidth: '150px' },
    { field: 'Notify Party Tel1', header: 'Notify Party Tel.1', type: 'vehicle', minWidth: '120px' },
    { field: 'Paid Amount', header: 'Paid Amount', type: 'vehicle', minWidth: '120px', format: 'price' },
    { field: 'Reg Month', header: 'Reg Month', type: 'vehicle', minWidth: '120px' },
    { field: 'Report Date', header: 'Report Date', type: 'vehicle', minWidth: '120px', format: 'date' },
    { field: 'Sailing Country', header: 'Sailing Country', type: 'vehicle', minWidth: '120px' },
    { field: 'Sales Agent', header: 'Sales Agent', type: 'vehicle', minWidth: '120px' },
    { field: 'Seat', header: 'Seat', type: 'vehicle', minWidth: '100px' },
    { field: 'Ship Name', header: 'Ship Name', type: 'vehicle', minWidth: '120px' },
    { field: 'Ship Type', header: 'Ship Type', type: 'vehicle', minWidth: '120px' },
    { field: 'Shipping Company', header: 'Shipping Company', type: 'vehicle', minWidth: '150px' },
    { field: 'Sold Date', header: 'Sold Date', type: 'vehicle', minWidth: '120px', format: 'date' },
    { field: 'Steering', header: 'Steering', type: 'vehicle', minWidth: '100px' },
    { field: 'Terms', header: 'Terms', type: 'vehicle', minWidth: '100px' },
    { field: 'Trans', header: 'Trans', type: 'vehicle', minWidth: '100px' },
    { field: 'Voyage No', header: 'Voyage No', type: 'vehicle', minWidth: '120px' },
    { field: 'Weight (kg)', header: 'Weight(kg)', type: 'vehicle', minWidth: '120px' },
    { field: 'Width (cm)', header: 'Width(cm)', type: 'vehicle', minWidth: '120px' },
    { field: 'Yard', header: 'Yard', type: 'vehicle', minWidth: '120px' },
    { field: 'Yard In Date', header: 'Yard In Date', type: 'vehicle', minWidth: '120px', format: 'date' },
    { field: 'Year', header: 'Year', type: 'vehicle', minWidth: '100px' },
    // Charge Fields
    { field: '1st Transport Charge', header: '1st Transport Charge', type: 'charge', minWidth: '150px', format: 'price' },
    { field: '2nd Transport Charge', header: '2nd Transport Charge', type: 'charge', minWidth: '150px', format: 'price' },
    { field: '3rd Transport Charge', header: '3rd Transport Charge', type: 'charge', minWidth: '150px', format: 'price' },
    { field: 'Additional Fee "Rikuso Co.,"', header: 'Additional Fee "Rikuso Co.,"', type: 'charge', minWidth: '180px', format: 'price' },
    { field: 'Additional Inspection Fee', header: 'Additional Inspection Fee', type: 'charge', minWidth: '180px', format: 'price' },
    { field: 'ATJ PSI', header: 'ATJ PSI', type: 'charge', minWidth: '120px', format: 'price' },
    { field: 'Auc Price Tax', header: 'Auc Price Tax', type: 'charge', minWidth: '120px', format: 'price' },
    { field: 'Auction Penalty', header: 'Auction Penalty', type: 'charge', minWidth: '150px', format: 'price' },
    { field: 'Auction Price', header: 'Auction Price', type: 'charge', minWidth: '120px', format: 'price' },
    { field: 'Auction Price + Tax', header: 'Auction Price + Tax', type: 'charge', minWidth: '150px', format: 'price' },
    { field: 'Automobile Tax', header: 'Automobile Tax', type: 'charge', minWidth: '120px', format: 'price' },
    { field: 'B/L Charges', header: 'B/L Charges', type: 'charge', minWidth: '120px', format: 'price' },
    { field: 'Bid charge', header: 'Bid Charge', type: 'charge', minWidth: '120px', format: 'price' },
    { field: 'Bid Charge + Tax', header: 'Bid Charge + Tax', type: 'charge', minWidth: '150px', format: 'price' },
    { field: 'Bid Charge Tax', header: 'Bid Charge Tax', type: 'charge', minWidth: '120px', format: 'price' },
    { field: 'Booking Agent Commision', header: 'Booking Agent Commision', type: 'charge', minWidth: '180px', format: 'price' },
    { field: 'Car Insurance', header: 'Car Insurance', type: 'charge', minWidth: '120px', format: 'price' },
    { field: 'CAT FEE', header: 'CAT FEE', type: 'charge', minWidth: '120px', format: 'price' },
    { field: 'Cleaning Fee', header: 'Cleaning Fee', type: 'charge', minWidth: '120px', format: 'price' },
    { field: 'Collection Fee', header: 'Collection Fee', type: 'charge', minWidth: '120px', format: 'price' },
    { field: 'Consumption tax', header: 'Consumption tax', type: 'charge', minWidth: '120px', format: 'price' },
    { field: 'Custom / Shipping Charge', header: 'Custom / Shipping Charge', type: 'charge', minWidth: '180px', format: 'price' },
    { field: 'Cutting CKD Fees', header: 'Cutting CKD Fees', type: 'charge', minWidth: '150px', format: 'price' },
    { field: 'DHL Docs Fee', header: 'DHL Docs Fee', type: 'charge', minWidth: '120px', format: 'price' },
    { field: 'Doc Fee', header: 'Doc Fee', type: 'charge', minWidth: '120px', format: 'price' },
    { field: 'Drage - CTN', header: 'Drage - CTN', type: 'charge', minWidth: '120px', format: 'price' },
    { field: 'EAA', header: 'EAA', type: 'charge', minWidth: '100px', format: 'price' },
    { field: 'EMS', header: 'EMS', type: 'charge', minWidth: '100px', format: 'price' },
    { field: 'Engine Number', header: 'Engine Number', type: 'charge', minWidth: '120px' },
    { field: 'EXTRA PARTS', header: 'EXTRA PARTS', type: 'charge', minWidth: '120px', format: 'price' },
    { field: 'FEDEX', header: 'FEDEX', type: 'charge', minWidth: '100px', format: 'price' },
    { field: 'Fuel Charge', header: 'Fuel Charge', type: 'charge', minWidth: '120px', format: 'price' },
    { field: 'Gas Removal Charge', header: 'Gas Removal Charge', type: 'charge', minWidth: '150px', format: 'price' },
    { field: 'Heat Treatment (FJI)', header: 'Heat Treatment (FJI)', type: 'charge', minWidth: '150px', format: 'price' },
    { field: 'Inner Cargo Charge', header: 'Inner Cargo Charge', type: 'charge', minWidth: '150px', format: 'price' },
    { field: 'ISL DOCS FEE', header: 'ISL DOCS FEE', type: 'charge', minWidth: '120px', format: 'price' },
    { field: 'Issuing Bank Fee', header: 'Issuing Bank Fee', type: 'charge', minWidth: '150px', format: 'price' },
    { field: 'JEVIC', header: 'JEVIC', type: 'charge', minWidth: '100px', format: 'price' },
    { field: 'LC Ammendment Fee', header: 'LC Ammendment Fee', type: 'charge', minWidth: '150px', format: 'price' },
    { field: 'LC Cable Charge', header: 'LC Cable Charge', type: 'charge', minWidth: '150px', format: 'price' },
    { field: 'Marine Insurance', header: 'Marine Insurance', type: 'charge', minWidth: '150px', format: 'price' },
    { field: 'MB INSP CANCEL FEE', header: 'MB INSP CANCEL FEE', type: 'charge', minWidth: '150px', format: 'price' },
    { field: 'Meigihekein Deposit', header: 'Meigihekein Deposit', type: 'charge', minWidth: '150px', format: 'price' },
    { field: 'Mileage repair', header: 'Mileage repair', type: 'charge', minWidth: '120px', format: 'price' },
    { field: 'Ocean Freight', header: 'Ocean Freight', type: 'charge', minWidth: '120px', format: 'price' },
    { field: 'Parts', header: 'Parts', type: 'charge', minWidth: '100px', format: 'price' },
    { field: 'Parts Disposal Fee', header: 'Parts Disposal Fee', type: 'charge', minWidth: '150px', format: 'price' },
    { field: 'Photo Shooting Fee', header: 'Photo Shooting Fee', type: 'charge', minWidth: '150px', format: 'price' },
    { field: 'Pre-Export Inspection', header: 'Pre-Export Inspection', type: 'charge', minWidth: '150px', format: 'price' },
    { field: 'QISJ', header: 'QISJ', type: 'charge', minWidth: '100px', format: 'price' },
    { field: 'Radiation Check Fee', header: 'Radiation Check Fee', type: 'charge', minWidth: '150px', format: 'price' },
    { field: 'Re-Auc Sold Price', header: 'Re-Auc Sold Price', type: 'charge', minWidth: '150px', format: 'price' },
    { field: 'Recycle Fee PAID', header: 'Recycle Fees Paid', type: 'charge', minWidth: '150px', format: 'price' },
    { field: 'Sales Commission', header: 'Sales Commission', type: 'charge', minWidth: '150px', format: 'price' },
    { field: 'Seal Fee', header: 'Seal Fee', type: 'charge', minWidth: '100px', format: 'price' },
    { field: 'Selling Charge shuppin', header: 'Selling Charge shuppin', type: 'charge', minWidth: '180px', format: 'price' },
    { field: 'Shipping Extra Costs', header: 'Shipping Extra Costs', type: 'charge', minWidth: '150px', format: 'price' },
    { field: 'Sold Charge Seyaku', header: 'Sold Charge Seyaku', type: 'charge', minWidth: '150px', format: 'price' },
    { field: 'Stamp Fee', header: 'Stamp Fee', type: 'charge', minWidth: '100px', format: 'price' },
    { field: 'SURRENDER FEE', header: 'SURRENDER FEE', type: 'charge', minWidth: '120px', format: 'price' },
    { field: 'THC', header: 'THC', type: 'charge', minWidth: '100px', format: 'price' },
    { field: 'Transfer Fee', header: 'Transfer Fee', type: 'charge', minWidth: '120px', format: 'price' },
    { field: 'Vanning', header: 'Vanning', type: 'charge', minWidth: '100px', format: 'price' },
    { field: 'Vehicle Repair', header: 'Vehicle Repair', type: 'charge', minWidth: '120px', format: 'price' },
    { field: 'Weight Tax', header: 'Weight Tax', type: 'charge', minWidth: '120px', format: 'price' },
    { field: 'Yard to Port YOKOMOCHI', header: 'Yard to Port YOKOMOCHI', type: 'charge', minWidth: '180px', format: 'price' },
    { field: 'Yard-Out Penalty', header: 'Yard-Out Penalty', type: 'charge', minWidth: '150px', format: 'price' },
    { field: 'Yen Exchange', header: 'Yen Exchange', type: 'charge', minWidth: '120px', format: 'price' },
    { field: 'YARD STORAGE FEE', header: 'YARD STORAGE FEE', type: 'charge', minWidth: '150px', format: 'price' },
    { field: 'Total Cost', header: 'Total Cost', type: 'charge', minWidth: '120px', format: 'price' },
    { field: 'Selling Price', header: 'Selling Price', type: 'charge', minWidth: '120px', format: 'price' },
  ];

  // Visible columns based on selected view
  visibleColumns: ColumnConfig[] = [];

  // State properties
  isLoading: boolean = false;
  isExportingExcel: boolean = false;
  searchTerm: string = '';
  currentPage: number = 1;
  selectedVehicles: string[] = [];
  showFiltersForm: boolean = false;

  // Filter properties
  filters: InventoryFilters = {};

  // Dropdown data
  yardsList: any[] = [];
  fuelTypesList: any[] = [];
  transmissionsList: any[] = [];
  shippingCompaniesList: any[] = [];
  yearOptions: any[] = [];

  // Buyer Name search properties
  buyerNameSearchTerm: string = '';
  selectedBuyerName: any = null;
  buyerNameSearchResults: any[] = [];
  showBuyerNameDropdown: boolean = false;
  isBuyerNameSearching: boolean = false;
  private buyerNameSearchSubject = new Subject<string>();

  // Sales Person search properties
  salesPersonSearchTerm: string = '';
  selectedSalesPerson: any = null;
  salesPersonSearchResults: any[] = [];
  showSalesPersonDropdown: boolean = false;
  isSalesPersonSearching: boolean = false;
  private salesPersonSearchSubject = new Subject<string>();

  // Ship Name search properties
  shipNameSearchTerm: string = '';
  selectedShipName: any = null;
  shipNameSearchResults: any[] = [];
  showShipNameDropdown: boolean = false;
  isShipNameSearching: boolean = false;
  private shipNameSearchSubject = new Subject<string>();

  // Source options
  sourceOptions = [
    { value: 'imperial', label: 'Imperial' },
    { value: 'others', label: 'Others' },
    { value: 'one_price', label: 'One Price' }
  ];

  // Inspection status options
  inspStatusOptions = [
    { value: 'In Process', label: 'In Process' },
    { value: 'Pending', label: 'Pending' },
    { value: 'Passed', label: 'Passed' },
    { value: 'Failed', label: 'Failed' }
  ];

  // Expose Math to template
  Math = Math;

  constructor(
    private _vehicleService: VehicleService,
    private _viewMasterService: ViewMasterService,
    private _vendorService: VendorService,
    private _fuelService: FuelService,
    private _transmissionService: TransmissionService,
    private _clientService: ClientService,
    private _userService: UserService,
    private _shipService: ShipService,
    private _generalService: GeneralService,
    private cdr: ChangeDetectorRef
  ) {
    super();
    this.setupBuyerNameSearchDebounce();
    this.setupSalesPersonSearchDebounce();
    this.setupShipNameSearchDebounce();
    this.generateYearOptions();
  }

  ngOnInit(): void {
    this.visibleColumns = [...this.allColumns]; // Show all columns by default
    this.loadViewMasters();
    this.loadVehicles();
    this.loadYards();
    this.loadFuelTypes();
    this.loadTransmissions();
    this.loadShippingCompanies();
  }

  loadViewMasters(): void {
    this.subscriptions.push(
      this._viewMasterService.GetData('1', '', { paginate: false }).subscribe({
        next: (response: any) => {
          if (response.status && response.data) {
            this.viewMasters = response.data || [];
          } else {
            this.viewMasters = [];
          }
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error loading view masters:', error);
          this.viewMasters = [];
          this.cdr.detectChanges();
        }
      })
    );
  }

  onViewChange(): void {
    if (!this.selectedViewMaster) {
      // No view selected, show all columns
      this.visibleColumns = [...this.allColumns];
      this.selectedViewMasterData = null;
    } else {
      // Find selected view master data
      this.selectedViewMasterData = this.viewMasters.find(vm => vm._id === this.selectedViewMaster);
      if (this.selectedViewMasterData) {
        const vehicleFields = this.selectedViewMasterData.vehicle_fields || [];
        const chargeFields = this.selectedViewMasterData.charges || [];
        const allowedFields = [...vehicleFields, ...chargeFields];

        // Filter columns based on selected view
        this.visibleColumns = this.allColumns.filter(col => allowedFields.includes(col.field));
      } else {
        this.visibleColumns = [...this.allColumns];
      }
    }
    this.cdr.detectChanges();
  }

  private resetPagination(): void {
    this.paginationInfo = {
      currentPage: 1,
      perPage: 20,
      total: 0,
      lastPage: 1,
      firstPage: 1
    };
  }

  loadVehicles(page: number = 1, search: string = '', filters: Record<string, any> = {}): void {
    this.isLoading = true;

    filters.append_type = "inventory";
    filters.panel_filters = "true";

    for(const key in filters) {
      if (filters[key] === '' || filters[key] === null) {
        delete filters[key];
      }
    }
    this.subscriptions.push(
      this._vehicleService.GetData(page.toString(), search, filters).subscribe({
        next: (response: PaginatedResponse<InventoryCar>) => {
          if (response.status && response.data) {
            this.vehicles = response.data.data || [];
            this.paginationInfo = response.data.pagination;
            this.currentPage = response.data.pagination.currentPage;
          } else {
            this.vehicles = [];
            this.resetPagination();
          }
          this.isLoading = false;
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error loading vehicles:', error);
          this.vehicles = [];
          this.resetPagination();
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      })
    );
  }

  onPageChange(page: number): void {
    this.loadVehicles(page, this.searchTerm);
  }

  onSearch(): void {
    this.currentPage = 1;
    this.loadVehicles(1, this.searchTerm);
  }

  // Filter methods
  toggleFilters(): void {
    this.showFiltersForm = !this.showFiltersForm;
  }

  applyFilters(): void {
    // Prepare filters for API call
    const apiFilters: Record<string, any> = { ...this.filters };

    // Handle buyer name
    if (this.filters.buyer_name) {
      apiFilters.buyer_name_id = this.filters.buyer_name._id;
      delete apiFilters.buyer_name;
    }

    // Handle sales person
    if (this.filters.sales_person) {
      apiFilters.sales_person_id = this.filters.sales_person._id;
      delete apiFilters.sales_person;
    }

    // Handle ship name
    if (this.filters.ship_name) {
      apiFilters.ship_name_id = this.filters.ship_name._id;
      delete apiFilters.ship_name;
    }

    // Handle source checkboxes
    if (this.filters.source && this.filters.source.length > 0) {
      apiFilters.source = this.filters.source.join(',');
    } else {
      delete apiFilters.source;
    }

    console.log('Applied filters:', apiFilters);
    this.loadVehicles(1, this.searchTerm, apiFilters);
  }

  clearFilters(): void {
    this.filters = {};
    this.searchTerm = '';

    // Clear search inputs
    this.clearBuyerNameSearch();
    this.clearSalesPersonSearch();
    this.clearShipNameSearch();

    this.loadVehicles(1, '', {});
  }

  hasActiveFilters(): boolean {
    return Object.values(this.filters).some(value => {
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      return value !== '' && value !== null && value !== undefined;
    });
  }

  getActiveFiltersCount(): number {
    return Object.values(this.filters).filter(value => {
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      return value !== '' && value !== null && value !== undefined;
    }).length;
  }

  // Helper methods for displaying data
  formatMileage(mileage: number): string {
    if (!mileage) return '-';
    return mileage.toLocaleString() + ' km';
  }

  formatPrice(price: number): string {
    if (!price) return '-';
    return '¥' + price.toLocaleString();
  }

  formatDate(dateString: string): string {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString();
  }

  // Get display value or fallback
  getDisplayValue(value: any, fallback: string = '-'): string {
    return value || fallback;
  }

  // Track by function for ngFor performance
  trackByFn(index: number, item: InventoryCar): string {
    return item._id || item.inventory_no || index.toString();
  }

  trackByColumn(index: number, col: ColumnConfig): string {
    return col.field;
  }

  getTotalAuctionPrice(price_sheet: any): number {
    if (!price_sheet) return 0;
    return (price_sheet.description?.auction_price?.actual || 0) + (price_sheet.description?.auction_price_tax?.actual || 0);
  }

  getTotalBidCharge(price_sheet: any): number {
    if (!price_sheet) return 0;
    return (price_sheet.description?.bid_charge?.actual || 0) + (price_sheet.description?.bid_price_tax?.actual || 0);
  }

  // Get column value for dynamic rendering
  getColumnValue(vehicle: any, column: ColumnConfig): string {
    const fieldMap: Record<string, () => any> = {
      // Vehicle Fields
      'Arrival port': () => vehicle.invoice?.ship?.destination_port,
      'Auction date': () => vehicle.auction_date,
      'Auction Name': () => vehicle.auction_name,
      'Avg Ex Rate': () => vehicle.avg_ex_rate,
      'Balance Amount': () => vehicle.invoice?.balance,
      'Balance Finalized Date': () => vehicle.balance_finalized_date,
      'Book Req. Date': () => vehicle.book_req_date,
      'Booking Status': () => vehicle.booking_status || 'Pending',
      'Buyer Name': () => vehicle.invoice?.order?.buyer_consignee_name,
      'Car Category': () => vehicle.category_name || vehicle.car_category,
      'CC': () => vehicle.engine || vehicle.engine_cc,
      'Charges': () => vehicle.charges,
      'Chassis Number': () => vehicle.vin_no || vehicle.chassis_no,
      'Color': () => vehicle.color || vehicle.exterior_color,
      'Consignee Address1': () => vehicle.invoice?.order?.buyer_street_address,
      'Consignee City': () => vehicle.invoice?.order?.buyer_city,
      'Consignee Country': () => vehicle.invoice?.order?.buyer_country,
      'Consignee Email': () => vehicle.invoice?.order?.buyer_email_address,
      'Consignee Name': () => vehicle.invoice?.order?.buyer_consignee_name,
      'Consignee Tel1': () => vehicle.invoice?.order?.buyer_telephone_no,
      'Consignee Tel2': () => vehicle.invoice?.order?.buyer_telephone_no_2,
      'Container Number': () => vehicle.invoice?.ship?.container_number,
      'CTN Group No.': () => vehicle.invoice?.order?.group_no,
      'Currency': () => vehicle.invoice?.item?.currency,
      'Departing Port': () => vehicle.invoice?.ship?.sailing_port,
      'Doors': () => vehicle.doors,
      'Drive': () => vehicle.drive_2wd_4wd || vehicle.steering,
      'Engine Model': () => vehicle.engine_model || vehicle.engine,
      'ETA': () => vehicle.invoice?.ship?.arrival_date,
      'ETD': () => vehicle.invoice?.ship?.sailing_date,
      'Ext. Grade': () => vehicle.est_grade,
      'Freight Rate': () => vehicle.price_sheet?.shipping_costs?.freight_rate?.actual,
      'Freight Amount': () => vehicle.price_sheet?.shipping_costs?.freight_rate?.actual,
      'Fuel': () => vehicle.fuel_type,
      'Height (cm)': () => vehicle.car_height,
      'Insp. Date': () => vehicle.inspection_apply_date,
      'Insp. Status': () => vehicle.inspection_status,
      'Inv. Amount': () => vehicle.invoice?.balance,
      'Invoice Total': () => vehicle.invoice?.invoice_amount,
      'Length (cm)': () => vehicle.car_length,
      'Load Capacity(kg)': () => vehicle.lead_capacity_kg,
      'Lot Number': () => vehicle.lot_no,
      'M3': () => vehicle.m3,
      'Make': () => vehicle.company_name,
      'Maker Grade': () => vehicle.maker_grade,
      'Masho Date': () => vehicle.masho_apply_date,
      'Master BOL No. (BL Number)': () => vehicle.master_bol_no || vehicle.bl_number,
      'Mfg Month': () => vehicle.manufacture_month,
      'Mfg Year': () => vehicle.manufacture_year,
      'Mileage (km)': () => vehicle.mileage,
      'Model': () => vehicle.name,
      'Model Code': () => vehicle.model_code_obj?.code,
      'Notify Party Address1': () => vehicle.notify_party_address_1,
      'Notify Party City': () => vehicle.notify_party_city,
      'Notify Party Country': () => vehicle.notify_party_country,
      'Notify Party Email': () => vehicle.notify_party_email,
      'Notify Party Name': () => vehicle.notify_party_name,
      'Notify Party Tel1': () => vehicle.notify_party_tel_1,
      'Paid Amount': () => vehicle.invoice?.paid,
      'Reg Month': () => vehicle.registration_month,
      'Report Date': () => vehicle.report_date,
      'Sailing Country': () => vehicle.invoice?.ship?.sailing_country,
      'Sales Agent': () => vehicle.sales_person?.name,
      'Seat': () => vehicle.seats,
      'Ship Name': () => vehicle.invoice?.ship?.name,
      'Ship Type': () => vehicle.invoice?.order?.ship_type,
      'Shipping Company': () => vehicle.invoice?.ship?.company,
      'Sold Date': () => vehicle.sold_date,
      'Steering': () => vehicle.steering,
      'Terms': () => vehicle.terms,
      'Trans': () => vehicle.transmission,
      'Voyage No': () => vehicle.invoice?.ship?.voyage_no,
      'Weight (kg)': () => vehicle.weight,
      'Width (cm)': () => vehicle.car_width,
      'Yard': () => vehicle.yard_name,
      'Yard In Date': () => vehicle.yard_date,
      'Year': () => vehicle.year,
      // Charge Fields
      '1st Transport Charge': () => vehicle.price_sheet?.local_transport_rikuso?.first_transport_charge?.actual,
      '2nd Transport Charge': () => vehicle.price_sheet?.local_transport_rikuso?.second_transport_charge?.actual,
      '3rd Transport Charge': () => vehicle.price_sheet?.local_transport_rikuso?.third_transport_charge?.actual,
      'Additional Fee "Rikuso Co.,"': () => vehicle.price_sheet?.local_transport_rikuso?.additional_fee_rikuso_co?.actual,
      'Additional Inspection Fee': () => vehicle.price_sheet?.inspection?.additional_inspection_fee?.actual,
      'ATJ PSI': () => vehicle.price_sheet?.pre_export_inspection?.atj_psi?.actual,
      'Auc Price Tax': () => vehicle.price_sheet?.description?.auction_price_tax?.actual,
      'Auction Penalty': () => vehicle.price_sheet?.local_transport_rikuso?.auction_penalty?.actual,
      'Auction Price': () => vehicle.price_sheet?.description?.auction_price?.actual,
      'Auction Price + Tax': () => this.getTotalAuctionPrice(vehicle.price_sheet),
      'Automobile Tax': () => vehicle.price_sheet?.refunds?.automobile_tax?.actual,
      'B/L Charges': () => vehicle.price_sheet?.shipping_costs?.bl_charges?.actual,
      'Bid charge': () => vehicle.price_sheet?.description?.bid_charge?.actual,
      'Bid Charge + Tax': () => this.getTotalBidCharge(vehicle.price_sheet),
      'Bid Charge Tax': () => vehicle.price_sheet?.description?.bid_price_tax?.actual,
      'Booking Agent Commision': () => vehicle.price_sheet?.isl_internal?.sales_commission?.actual,
      'Car Insurance': () => vehicle.price_sheet?.refunds?.car_insurance?.actual,
      'CAT FEE': () => vehicle.price_sheet?.pre_export_inspection?.cat_fee?.actual,
      'Cleaning Fee': () => vehicle.price_sheet?.yard_cost?.cleaning_fee?.actual,
      'Collection Fee': () => vehicle.price_sheet?.bank_charges?.collection_fee?.actual,
      'Consumption tax': () => vehicle.price_sheet?.refunds?.consumption_tax?.actual,
      'Custom / Shipping Charge': () => vehicle.price_sheet?.yard_cost?.custom_shipping_charge?.actual,
      'Cutting CKD Fees': () => vehicle.price_sheet?.yard_cost?.cutting_ckd_fees?.actual,
      'DHL Docs Fee': () => vehicle.price_sheet?.airmail_charges?.dhl_docs_fee?.actual,
      'Doc Fee': () => vehicle.price_sheet?.shipping_costs?.doc_fee?.actual,
      'Drage - CTN': () => vehicle.price_sheet?.shipping_costs?.cargo_ctn?.actual,
      'EAA': () => vehicle.price_sheet?.pre_export_inspection?.eaa?.actual,
      'EMS': () => vehicle.price_sheet?.airmail_charges?.ems?.actual,
      'Engine Number': () => vehicle.engine_no,
      'EXTRA PARTS': () => vehicle.price_sheet?.extra_charges?.extra_parts?.actual,
      'FEDEX': () => vehicle.price_sheet?.airmail_charges?.fedex?.actual,
      'Fuel Charge': () => vehicle.price_sheet?.local_transport_rikuso?.fuel_charge?.actual,
      'Gas Removal Charge': () => vehicle.price_sheet?.yard_cost?.gas_removal_charge?.actual,
      'Heat Treatment (FJI)': () => vehicle.price_sheet?.pre_export_inspection?.heat_treatment_fuj?.actual,
      'Inner Cargo Charge': () => vehicle.price_sheet?.yard_cost?.inner_cargo_charge?.actual,


      'ISL DOCS FEE': () => vehicle.price_sheet?.fees?.isl_docs_fee?.actual,
      'Issuing Bank Fee': () => vehicle.price_sheet?.bank_charges?.issuing_bank_fee?.actual,
      'JEVIC': () => vehicle.price_sheet?.pre_export_inspection?.jevic?.actual,


      'LC Ammendment Fee': () => vehicle.price_sheet?.bank_charges?.lc_ammendment_fee?.actual,
      'LC Cable Charge': () => vehicle.price_sheet?.bank_charges?.lc_cable_charge?.actual,
      'Marine Insurance': () => vehicle.price_sheet?.isl_internal?.marine_insurance?.actual,
      'MB INSP CANCEL FEE': () => vehicle.price_sheet?.pre_export_inspection?.mb_insp_cancel_fee?.actual,
      'Meigihekein Deposit': () => vehicle.price_sheet?.deposits?.meigihekein_deposit?.actual,
      'Mileage repair': () => vehicle.price_sheet?.repairs?.mileage_repair?.actual,
      'Ocean Freight': () => vehicle.price_sheet?.shipping_costs?.ocean_freight?.actual,
      'Parts': () => vehicle.price_sheet?.yard_cost?.parts?.actual,
      'Parts Disposal Fee': () => vehicle.price_sheet?.yard_cost?.parts_disposal_fee?.actual,
      'Photo Shooting Fee': () => vehicle.price_sheet?.yard_cost?.photo_shooting_fee?.actual,
      'Pre-Export Inspection': () => vehicle.price_sheet?.pre_export_inspection?.pre_export_inspection?.actual,
      'QISJ': () => vehicle.price_sheet?.inspection?.qisj?.actual,
      'Radiation Check Fee': () => vehicle.price_sheet?.refunds?.radiation_check_fee?.actual,
      'Re-Auc Sold Price': () => vehicle.price_sheet?.description?.re_auc_sold_price?.actual,
      'Recycle Fee PAID': () => vehicle.price_sheet?.refunds?.recycle_fee_paid?.actual,
      'Sales Commission': () => vehicle.price_sheet?.isl_internal?.sales_commission?.actual,
      'Seal Fee': () => vehicle.price_sheet?.shipping_costs?.seal_fee?.actual,
      'Selling Charge shuppin': () => vehicle.price_sheet?.description?.selling_charge_shuppin?.actual,
      'Shipping Extra Costs': () => vehicle.price_sheet?.shipping_costs?.shipping_extra_costs?.actual,
      'Sold Charge Seyaku': () => vehicle.price_sheet?.description?.sold_charge_seiyaku?.actual,
      'Stamp Fee': () => vehicle.price_sheet?.bank_charges?.stamp_fee?.actual,
      'SURRENDER FEE': () => vehicle.price_sheet?.shipping_costs?.surrender_fee?.actual,
      'THC': () => vehicle.price_sheet?.shipping_costs?.thc?.actual,
      'Transfer Fee': () => vehicle.price_sheet?.bank_charges?.transfer_fee?.actual,
      'Vanning': () => vehicle.price_sheet?.yard_cost?.vanning?.actual,
      'Vehicle Repair': () => vehicle.price_sheet?.yard_cost?.vehicle_repair?.actual,
      'Weight Tax': () => vehicle.price_sheet?.refunds?.weight_tax?.actual,
      'Yard to Port YOKOMOCHI': () => vehicle.price_sheet?.yard_cost?.yard_to_port_yokohama?.actual,
      'Yard-Out Penalty': () => vehicle.price_sheet?.yard_cost?.yard_cut_penalty?.actual,
      'Yen Exchange': () => vehicle.price_sheet?.bank_charges?.yen_exchange?.actual,
      'YARD STORAGE FEE': () => vehicle.price_sheet?.yard_cost?.yard_storage_fee?.actual,
      'Total Cost': () => vehicle.total_cost,
      'Selling Price': () => vehicle.price_sheet?.description?.selling_price?.actual,
    };

    const getValue = fieldMap[column.field];
    const rawValue = getValue ? getValue() : null;

    // Format the value based on column type
    if (rawValue === null || rawValue === undefined || rawValue === '') {
      return '-';
    }

    switch (column.format) {
      case 'price':
        return this.formatPrice(+rawValue);
      case 'date':
        return this.formatDate(rawValue);
      case 'mileage':
        return this.formatMileage(+rawValue);
      default:
        return String(rawValue);
    }
  }

  // Checkbox selection methods
  isVehicleSelected(vehicleId: string): boolean {
    return this.selectedVehicles.includes(vehicleId);
  }

  toggleVehicleSelection(vehicleId: string, event: any): void {
    if (event.target.checked) {
      if (!this.selectedVehicles.includes(vehicleId)) {
        this.selectedVehicles.push(vehicleId);
      }
    } else {
      this.selectedVehicles = this.selectedVehicles.filter(id => id !== vehicleId);
    }
  }

  isAllSelected(): boolean {
    return this.vehicles.length > 0 && this.selectedVehicles.length === this.vehicles.length;
  }

  isIndeterminate(): boolean {
    return this.selectedVehicles.length > 0 && this.selectedVehicles.length < this.vehicles.length;
  }

  toggleSelectAll(event: any): void {
    if (event.target.checked) {
      this.selectedVehicles = this.vehicles.map(vehicle => vehicle._id);
    } else {
      this.selectedVehicles = [];
    }
  }

  copySelectedISL(): void {
    if (this.selectedVehicles.length === 0) {
      return;
    }

    // Get car_no values for selected vehicles
    const selectedCarNos = this.vehicles
      .filter(vehicle => this.selectedVehicles.includes(vehicle._id))
      .map(vehicle => vehicle.car_no || vehicle.stock_no)
      .filter(carNo => carNo) // Remove empty values
      .join(',');

    if (selectedCarNos) {
      // Copy to clipboard
      navigator.clipboard.writeText(selectedCarNos).then(() => {
        // Show success message (you can replace this with your preferred notification method)
        console.log('ISL numbers copied to clipboard:', selectedCarNos);
        alert(`${this.selectedVehicles.length} ISL numbers copied to clipboard!`);
      }).catch(err => {
        console.error('Failed to copy to clipboard:', err);
        alert('Failed to copy to clipboard. Please try again.');
      });
    }
  }

  // Data loading methods for dropdowns
  generateYearOptions(): void {
    const currentYear = new Date().getFullYear();
    this.yearOptions = [];
    for (let year = 1990; year <= currentYear; year++) {
      this.yearOptions.push({ value: year.toString(), label: year.toString() });
    }
  }

  loadYards(): void {
    this.subscriptions.push(
      this._vendorService.GetData('1', '', { type: 'yard', paginate: false }).subscribe({
        next: (response: any) => {
          if (response.status && response.data) {
            this.yardsList = response.data.data || response.data || [];
          }
        },
        error: (error: any) => {
          console.error('Error loading yards:', error);
          this.yardsList = [];
        }
      })
    );
  }

  loadFuelTypes(): void {
    this.subscriptions.push(
      this._fuelService.GetData('1', '', { paginate: false }).subscribe({
        next: (response: any) => {
          if (response.status && response.data) {
            this.fuelTypesList = response.data.data || response.data || [];
          }
        },
        error: (error: any) => {
          console.error('Error loading fuel types:', error);
          this.fuelTypesList = [];
        }
      })
    );
  }

  loadTransmissions(): void {
    this.subscriptions.push(
      this._transmissionService.GetData('1', '', { paginate: false }).subscribe({
        next: (response: any) => {
          if (response.status && response.data) {
            this.transmissionsList = response.data.data || response.data || [];
          }
        },
        error: (error: any) => {
          console.error('Error loading transmissions:', error);
          this.transmissionsList = [];
        }
      })
    );
  }

  loadShippingCompanies(): void {
    this.subscriptions.push(
      this._vendorService.GetData('1', '', { type: 'shipping', paginate: false }).subscribe({
        next: (response: any) => {
          if (response.status && response.data) {
            this.shippingCompaniesList = response.data.data || response.data || [];
          }
        },
        error: (error: any) => {
          console.error('Error loading shipping companies:', error);
          this.shippingCompaniesList = [];
        }
      })
    );
  }

  // Source checkbox handling
  onSourceChange(value: string, checked: boolean): void {
    if (!this.filters.source) {
      this.filters.source = [];
    }

    if (checked) {
      if (!this.filters.source.includes(value)) {
        this.filters.source.push(value);
      }
    } else {
      this.filters.source = this.filters.source.filter(item => item !== value);
    }
  }

  isSourceSelected(value: string): boolean {
    return this.filters.source ? this.filters.source.includes(value) : false;
  }

  // Buyer Name search methods
  private setupBuyerNameSearchDebounce(): void {
    this.buyerNameSearchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(searchTerm => {
      this.searchBuyerNames(searchTerm);
    });
  }

  onBuyerNameSearchInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.buyerNameSearchTerm = target.value;
    this.selectedBuyerName = null;
    this.buyerNameSearchSubject.next(this.buyerNameSearchTerm);
    this.showBuyerNameDropdown = true;
  }

  onBuyerNameInputFocus(): void {
    if (this.buyerNameSearchResults.length > 0) {
      this.showBuyerNameDropdown = true;
    }
  }

  onBuyerNameInputBlur(): void {
    setTimeout(() => {
      this.showBuyerNameDropdown = false;
    }, 200);
  }

  private searchBuyerNames(searchTerm: string): void {
    if (!searchTerm || searchTerm.length < 2) {
      this.buyerNameSearchResults = [];
      this.showBuyerNameDropdown = false;
      return;
    }

    this.isBuyerNameSearching = true;
    this.subscriptions.push(
      this._clientService.GetData('1', searchTerm).subscribe({
        next: (response: any) => {
          this.isBuyerNameSearching = false;
          if (response.status && response.data && response.data.data) {
            this.buyerNameSearchResults = response.data.data;
            this.showBuyerNameDropdown = this.buyerNameSearchResults.length > 0;
          } else {
            this.buyerNameSearchResults = [];
            this.showBuyerNameDropdown = false;
          }
        },
        error: (error: any) => {
          this.isBuyerNameSearching = false;
          console.error('Error searching buyer names:', error);
          this.buyerNameSearchResults = [];
          this.showBuyerNameDropdown = false;
        }
      })
    );
  }

  selectBuyerName(buyerName: any): void {
    this.selectedBuyerName = buyerName;
    this.buyerNameSearchTerm = this.getBuyerNameDisplayName(buyerName);
    this.showBuyerNameDropdown = false;
    this.buyerNameSearchResults = [];
    this.filters.buyer_name = buyerName;
  }

  clearBuyerNameSearch(): void {
    this.buyerNameSearchTerm = '';
    this.selectedBuyerName = null;
    this.showBuyerNameDropdown = false;
    this.buyerNameSearchResults = [];
    this.filters.buyer_name = null;
  }

  getBuyerNameDisplayName(buyerName: any): string {
    if (buyerName.name && buyerName.company) {
      return `${buyerName.name}, ${buyerName.company}`;
    }
    return `${buyerName.name || ''} ${buyerName.last_name || ''}`.trim() || buyerName.email || 'Unknown Customer';
  }

  // Sales Person search methods
  private setupSalesPersonSearchDebounce(): void {
    this.salesPersonSearchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(searchTerm => {
      this.searchSalesPersons(searchTerm);
    });
  }

  onSalesPersonSearchInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.salesPersonSearchTerm = target.value;
    this.selectedSalesPerson = null;
    this.salesPersonSearchSubject.next(this.salesPersonSearchTerm);
    this.showSalesPersonDropdown = true;
  }

  onSalesPersonInputFocus(): void {
    if (this.salesPersonSearchResults.length > 0) {
      this.showSalesPersonDropdown = true;
    }
  }

  onSalesPersonInputBlur(): void {
    setTimeout(() => {
      this.showSalesPersonDropdown = false;
    }, 200);
  }

  private searchSalesPersons(searchTerm: string): void {
    if (!searchTerm || searchTerm.length < 2) {
      this.salesPersonSearchResults = [];
      this.showSalesPersonDropdown = false;
      return;
    }

    this.isSalesPersonSearching = true;
    this.subscriptions.push(
      this._userService.GetData('1', searchTerm, { is_primary_agent: true }).subscribe({
        next: (response: any) => {
          this.isSalesPersonSearching = false;
          if (response.status && response.data && response.data.data) {
            this.salesPersonSearchResults = response.data.data;
            this.showSalesPersonDropdown = this.salesPersonSearchResults.length > 0;
          } else {
            this.salesPersonSearchResults = [];
            this.showSalesPersonDropdown = false;
          }
        },
        error: (error: any) => {
          this.isSalesPersonSearching = false;
          console.error('Error searching sales persons:', error);
          this.salesPersonSearchResults = [];
          this.showSalesPersonDropdown = false;
        }
      })
    );
  }

  selectSalesPerson(salesPerson: any): void {
    this.selectedSalesPerson = salesPerson;
    this.salesPersonSearchTerm = this.getSalesPersonDisplayName(salesPerson);
    this.showSalesPersonDropdown = false;
    this.salesPersonSearchResults = [];
    this.filters.sales_person = salesPerson;
  }

  clearSalesPersonSearch(): void {
    this.salesPersonSearchTerm = '';
    this.selectedSalesPerson = null;
    this.showSalesPersonDropdown = false;
    this.salesPersonSearchResults = [];
    this.filters.sales_person = null;
  }

  getSalesPersonDisplayName(salesPerson: any): string {
    return `${salesPerson.name || ''} ${salesPerson.last_name || ''}`.trim() || salesPerson.email || 'Unknown Sales Person';
  }

  // Ship Name search methods
  private setupShipNameSearchDebounce(): void {
    this.shipNameSearchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(searchTerm => {
      this.searchShipNames(searchTerm);
    });
  }

  onShipNameSearchInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.shipNameSearchTerm = target.value;
    this.selectedShipName = null;
    this.shipNameSearchSubject.next(this.shipNameSearchTerm);
    this.showShipNameDropdown = true;
  }

  onShipNameInputFocus(): void {
    if (this.shipNameSearchResults.length > 0) {
      this.showShipNameDropdown = true;
    }
  }

  onShipNameInputBlur(): void {
    setTimeout(() => {
      this.showShipNameDropdown = false;
    }, 200);
  }

  private searchShipNames(searchTerm: string): void {
    if (!searchTerm || searchTerm.length < 2) {
      this.shipNameSearchResults = [];
      this.showShipNameDropdown = false;
      return;
    }

    this.isShipNameSearching = true;
    this.subscriptions.push(
      this._shipService.GetData('1', searchTerm, { paginate: false }).subscribe({
        next: (response: any) => {
          this.isShipNameSearching = false;
          if (response.status && response.data) {
            this.shipNameSearchResults = response.data.data || response.data || [];
            this.showShipNameDropdown = this.shipNameSearchResults.length > 0;
          } else {
            this.shipNameSearchResults = [];
            this.showShipNameDropdown = false;
          }
        },
        error: (error: any) => {
          this.isShipNameSearching = false;
          console.error('Error searching ship names:', error);
          this.shipNameSearchResults = [];
          this.showShipNameDropdown = false;
        }
      })
    );
  }

  selectShipName(shipName: any): void {
    this.selectedShipName = shipName;
    this.shipNameSearchTerm = this.getShipNameDisplayName(shipName);
    this.showShipNameDropdown = false;
    this.shipNameSearchResults = [];
    this.filters.ship_name = shipName;
  }

  clearShipNameSearch(): void {
    this.shipNameSearchTerm = '';
    this.selectedShipName = null;
    this.showShipNameDropdown = false;
    this.shipNameSearchResults = [];
    this.filters.ship_name = null;
  }

  getShipNameDisplayName(shipName: any): string {
    return shipName.name || shipName.ship_name || 'Unknown Ship';
  }

  // Export Excel method
  exportExcel(): void {
    this.isExportingExcel = true;

    // Prepare filters for API call
    const apiFilters: Record<string, any> = { ...this.filters };

    // Handle buyer name
    if (this.filters.buyer_name) {
      apiFilters.buyer_name_id = this.filters.buyer_name._id;
      delete apiFilters.buyer_name;
    }

    // Handle sales person
    if (this.filters.sales_person) {
      apiFilters.sales_person_id = this.filters.sales_person._id;
      delete apiFilters.sales_person;
    }

    // Handle ship name
    if (this.filters.ship_name) {
      apiFilters.ship_name_id = this.filters.ship_name._id;
      delete apiFilters.ship_name;
    }

    // Handle source checkboxes
    if (this.filters.source && this.filters.source.length > 0) {
      apiFilters.source = this.filters.source.join(',');
    } else {
      delete apiFilters.source;
    }

    let selected_fields:any = []

    if(this.selectedViewMaster){
      selected_fields = [...this.selectedViewMasterData.vehicle_fields, ...this.selectedViewMasterData.charges];
    }

    // Prepare the request body
    const requestBody = {
      ...apiFilters,
      type: 'vehicle',
      panel_filters: 'true',
      append_type: 'inventory',
      vehicle_type: 'inventory',
      excel_name: 'Inventory Report',
      selected_fields
    };

    this.subscriptions.push(
      this._generalService.generateExcelPost(requestBody).subscribe({
        next: (response: any) => {
          this.isExportingExcel = false;
          console.log('Excel export response:', response);

          if (response.status && response.data && response.data.url) {
            // Open the Excel file URL in a new tab
            window.open(response.data.url, '_blank');
          } else {
            // Show error message if no URL is returned
            Swal.fire({
              text: 'Failed to generate Excel file. No URL received.',
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                confirmButton: "btn fw-bold btn-primary",
              }
            });
          }
        },
        error: (error: any) => {
          this.isExportingExcel = false;
          console.error('Error exporting Excel:', error);
          Swal.fire({
            text: 'An error occurred while exporting Excel file.',
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn fw-bold btn-primary",
            }
          });
        }
      })
    );
  }

}
